import React from 'react';
import logo from '../images/logo.png';
import { Link } from "react-router-dom";
import Register from './Register';

const Navbar = (props) => {
  const logostyle = {
    width: '185px',
    height: '55px'
  };

  return (

    <nav class="navbar navbar-expand-lg navbar-light bg-light fixed-top">
      <div class="container-fluid">
        <a class="navbar-brand" href="#"><img src={logo} style={logostyle} className="mr-auto" /></a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            {/* <li class="nav-item">
              <a class="nav-link active" aria-current="page" href="#">Home</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#">Link</a>
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                Dropdown
              </a>
              <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                <li><a class="dropdown-item" href="#">Action</a></li>
                <li><a class="dropdown-item" href="#">Another action</a></li>
                <li><hr class="dropdown-divider" /></li>
                <li><a class="dropdown-item" href="#">Something else here</a></li>
              </ul>
            </li>
            <li class="nav-item">
              <a class="nav-link disabled" href="#" tabindex="-1" aria-disabled="true">Disabled</a>
            </li> */}
          </ul>
          <div class="d-flex">
            <ul className="navbar-nav">

              <li className="nav-item">
                <a className="nav-link btn btn-outline-light m-1"><i className="fa fa-user mr-1"></i> <small>{props.user.first_name}  {props.user.last_name}</small></a>
              </li>
            
                <Register accessToken={props.accessToken}/>
          
              <li className="nav-item" onClick={props.logoutUser}>
                <a className="nav-link btn btn-outline-warning m-2"><i className="fas fa-sign-out-alt mx-2"></i> <small className='mx-1'>Signout</small></a>
              </li>

            </ul>
          </div>
        </div>
      </div>
    </nav>

  );
}

export default Navbar;
